import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import BrandingSection from './components/BrandingSection';
import OurCollection from './components/OurCollection';
import ProductDetail from './components/ProductDetail';
import Footer from './components/Footer';

// Home Page Component
const HomePage = () => (
  <>
    <Header />
    <Hero />
    <BrandingSection />
    <OurCollection />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;